import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  async getPulse(devices, type, mode = 'standard') {
    try {
      // Use satellite endpoint for sat mode when fetching GPS or RPM data
      const isSatMode = mode === 'sat';
      let processedType = type;

      if (isSatMode) {
        if (type === 'gps') {
          processedType = 'satellite/gps';
        } else if (type === 'rpm') {
          processedType = 'satellite/rpm';
        } else if (type === 'ae') {
          processedType = 'satellite/ae';
        }
      }

      const config = {
        params: { device: devices },
        cancelToken: getNewCancelToken(),
      };
      const response = await axiosInstance.get(`/series/device/${processedType}/pulse`, config);
      // Backend ini balikin HTTP 200 walau ditolak izin - errorCode 412 ada di body,
      // bukan di HTTP status, jadi axios gak throw. Harus dicek manual di sini, bukan
      // di catch. 412 = ditolak izin (beda kasus sama "beneran gak ada data") - jangan
      // disamain jadi [], biar pemanggil bisa bedain "sensor gak ada/mati" vs "emang
      // gak boleh diliat".
      if (response?.data?.status?.errorCode === 412) {
        return null;
      }
      return response?.data?.data?.series || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },
};
